require('./adGeneratorController');

"use strict";

angular.module('app.admin.adGenerator', [
    'app.admin.adGenerator.adGeneratorController'
])
.config([
    '$stateProvider',
    function ($stateProvider) {
        $stateProvider.state('app.admin.adGenerator', {
            url: '/ad_generator',
            controller: 'app.admin.adGenerator.adGeneratorController',
            templateUrl: 'components/admin/adGenerator/adGeneratorView.html',
            title: 'Intelligent Ad Generator'
        });
    }
]);


// WEBPACK FOOTER //
// ./app.v2/components/admin/adGenerator/adGenerator.js